var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXml = function SvgXml(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6.1 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18.1 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.6 10.5 18.1 6h4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#50BEE8",
    d: "M19.6 19.5c0 .413-.337.75-.75.75H2.35a.75.75 0 0 1-.75-.75V12c0-.412.338-.75.75-.75h16.5c.413 0 .75.338.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6.254 15.29 1.044-1.308c.311-.407.917.114.576.504-.36.426-.737.888-1.098 1.36L8 17.37c.329.45-.33.882-.654.438l-1.103-1.415-1.086 1.445c-.306.437-.984-.054-.641-.462l1.205-1.53c-.378-.473-.744-.934-1.109-1.36-.378-.45.324-.911.6-.491zM9.534 15.368v2.218c0 .265-.216.414-.431.414-.192 0-.36-.15-.36-.414V14.21a.4.4 0 0 1 .36-.415c.173 0 .275.103.377.217l1.32 1.78 1.367-1.847c.198-.245.684-.15.684.265v3.376c0 .265-.168.414-.36.414-.216 0-.384-.15-.384-.414v-2.218l-.996 1.259c-.215.265-.485.265-.683 0zM13.895 14.21c0-.198.168-.366.378-.366.192 0 .354.169.354.366v3.005h1.631c.587 0 .6.785 0 .785h-1.984c-.21 0-.378-.15-.378-.366z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M18.85 20.25H4.6V21h14.25c.413 0 .75-.337.75-.75v-.75c0 .413-.337.75-.75.75"
  })));
};
export default SvgXml;